import Vue from 'vue';
import VueGoogleMaps from 'gmap-vue';
import { readMeta } from '../lib/page';
import { accountId } from '../lib/jwt';
import { sendSegmentPageview } from '../lib/segment';
import { initGrowthbook } from '@/lib/growthbook';
import { setupBraze } from '../lib/braze';

/* eslint-disable */
declare global {
  interface Window {
    dataLayer: any[];
    analytics: any;
    google: any;
  }
}
/* eslint-enable */

window.dataLayer = window.dataLayer || [];

const Sittercity = Vue.extend({
  props: {
    skipSegmentPageEvent: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ssoUuid(): string | null {
      return accountId();
    },
    sessionID(): string | null {
      return readMeta('session');
    },
    siftKey(): string | null {
      return readMeta('sift');
    },
    trackSift(): string | null {
      return readMeta('track_sift');
    },
  },
  mounted() {
    if (this.$options.name && !this.skipSegmentPageEvent) {
      sendSegmentPageview(this.$options.name);
    }

    const script = document.querySelector('#_sift');
    if (this.ssoUuid && script && this.trackSift) {
      const u = this.ssoUuid;
      script.addEventListener('load', () => {
        const sift = (window as any)._sift;
        sift.push(['_setAccount', this.siftKey]);
        sift.push(['_setUserId', u]);
        sift.push(['_setSessionId', this.sessionID]);
        sift.push(['_trackPageview']);
      });
    }
  },
});

document.addEventListener('DOMContentLoaded', async () => {
  const googleMapsKey = readMeta('google_maps');

  if (googleMapsKey && googleMapsKey !== '') {
    // Check if Google Maps API is already loaded to prevent duplicate initialization
    const isGoogleMapsAlreadyLoaded = () => {
      return typeof window.google !== 'undefined' && window.google.maps && window.google.maps.places;
    };

    // Wait for Google Maps API to be available if it's being loaded globally
    const waitForGoogleMaps = (maxAttempts = 50, interval = 100) => {
      return new Promise((resolve) => {
        let attempts = 0;
        const checkInterval = setInterval(() => {
          attempts += 1;
          if (isGoogleMapsAlreadyLoaded() || attempts >= maxAttempts) {
            clearInterval(checkInterval);
            resolve(isGoogleMapsAlreadyLoaded());
          }
        }, interval);
      });
    };

    try {
      // Wait for Google Maps to be available (it might be loading from the global script)
      const mapsAvailable = await waitForGoogleMaps();

      if (mapsAvailable) {
        // Google Maps is already loaded, install VueGoogleMaps components without loading the API again
        Vue.use(VueGoogleMaps, {
          installComponents: true,
        });
      } else {
        // Google Maps not available, initialize VueGoogleMaps normally
        Vue.use(VueGoogleMaps, {
          load: {
            key: googleMapsKey,
            libraries: ['drawing', 'places'],
          },
          installComponents: true,
        });
      }
    } catch (error) {
      console.warn('Failed to check Google Maps availability:', error);
      // Fallback: try to initialize VueGoogleMaps anyway
      Vue.use(VueGoogleMaps, {
        load: {
          key: googleMapsKey,
          libraries: ['drawing', 'places'],
        },
        installComponents: true,
      });
    }
  }

  const e = document.createElement('script');
  e.src = 'https://cdn.siftscience.com/s.js';
  e.id = '_sift';
  document.body.appendChild(e);

  setupBraze();

  await initGrowthbook();
});

export default Sittercity;
